module.exports = __webpack_public_path__ + "static/media/dashboard-property-placeholder.41705d64.svg";